const BANNER_TYPE = {
  info: "info",
  warning: "warning",
  error: "error",
};

export default BANNER_TYPE;
